/* Monster Dip options – free replacement for Infinite Options */
(() => {
  if (customElements.get('monster-dips')) return;

  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_with_comma_separator') return `${withDots},${dec}`;
      if (key === 'amount_no_decimals_with_comma_separator') return withDots;
      if (key === 'amount_no_decimals') return withCommas;
      return `${withCommas}.${dec}`;
    });
  }

  class MonsterDips extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.select = this.querySelector('[data-md-dip]');
      this.extras = [...this.querySelectorAll('[data-md-extra]')];
      this.addEventListener('change', () => this.updatePrice());
      this.updatePrice();
      if (!this.form) return;
      // Capture phase: runs before the theme's own product-form submit handler.
      document.addEventListener('submit', (event) => this.onSubmit(event), true);
    }

    selectedOption() {
      return this.select.options[this.select.selectedIndex];
    }

    checkedExtras() {
      return this.extras.filter((el) => el.checked);
    }

    unitPrice() {
      const main = parseInt(this.selectedOption().dataset.price, 10);
      return this.checkedExtras().reduce((sum, el) => sum + parseInt(el.dataset.price, 10), main);
    }

    updatePrice() {
      const text = formatMoney(this.unitPrice(), this.dataset.moneyFormat);
      document
        .querySelectorAll(`#price-${this.dataset.sectionId} .price__regular .price-item--regular`)
        .forEach((el) => (el.textContent = text));
    }

    buildItems(quantity) {
      const option = this.selectedOption();
      const group = `${Date.now()}${Math.floor(Math.random() * 1000)}`;
      const dipName = option.value;
      const mainItem = {
        id: parseInt(option.dataset.bundleVariant || this.dataset.baseVariant, 10),
        quantity,
        properties: { _md_group: group },
      };
      if (!option.dataset.bundleVariant) mainItem.properties['Monster Dip'] = 'Ohne';

      const parentLabel =
        dipName === 'Ohne' ? this.dataset.productTitle : `${this.dataset.productTitle} (${dipName})`;
      const extraItems = this.checkedExtras().map((el) => ({
        id: parseInt(el.value, 10),
        quantity,
        properties: { 'Extra zu': parentLabel, _md_parent: group },
      }));
      // Shopify puts the last item of a multi-item add on top of the cart:
      // reversed order keeps "main line, then extras" in cart and checkout.
      return [...extraItems.reverse(), mainItem];
    }

    onSubmit(event) {
      if (event.target !== this.form) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const button = this.form.querySelector('[type="submit"]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      const qtyInput =
        document.getElementById(`Quantity-${this.dataset.sectionId}`) ||
        this.form.querySelector('[name="quantity"]');
      const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: this.buildItems(quantity) };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      this.setError(false);
      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            this.setError(response.description || response.message);
            return;
          }
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          const main = response.items.find((i) => i.properties && i.properties._md_group) || response.items[0];
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: main.variant_id, cartData: response });
          }
          cart.renderContents({ ...main, sections: response.sections });
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch(() => this.setError(window.cartStrings ? window.cartStrings.error : 'Fehler'))
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setError(message) {
      const section = this.form.closest('product-form') || document;
      const wrapper = section.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) {
        if (message) alert(message);
        return;
      }
      wrapper.toggleAttribute('hidden', !message);
      const text = wrapper.querySelector('.product-form__error-message');
      if (text && message) text.textContent = message;
    }
  }

  customElements.define('monster-dips', MonsterDips);
})();
